import { DATE_FORMAT_FOR_API } from "@/constants/datetime";
import { TCaseScheduleForm, TCaseScheduleItem, Talent, InterviewMethod } from "@/features/case/types/case";
import { normalizeString, toHourMinuteFormat } from "@/utils/string";
import { dayjs } from "@/utils/dayjs";

export const convertCaseSchedule = (payload: TCaseScheduleForm) => {
  const isConfirm = payload.isConfirm ?? false;
  const isOnlineInterview = payload.interviewMethod === InterviewMethod.ONLINE;

  return {
    dateTimeTalent: normalizeString(payload.dateTimeTalent) ?? "",
    isConfirm: payload.isConfirm || null,
    talentIds: payload.talentIds?.map((i) => Number(i)) || [],
    dateConfirm: isConfirm && payload.dateConfirm ? dayjs(payload.dateConfirm).format(DATE_FORMAT_FOR_API) : null,
    startTimeConfirm: isConfirm ? toHourMinuteFormat(payload.startTimeConfirm ?? "") || null : null,
    interviewMethod: isConfirm ? payload.interviewMethod || null : null,
    meetingToolType: isConfirm && isOnlineInterview ? payload.meetingToolType || null : null,
    meetingId: isConfirm && isOnlineInterview ? normalizeString(payload.meetingId) : null,
    passcode: isConfirm && isOnlineInterview ? normalizeString(payload.passcode) : null,
    url: isConfirm ? normalizeString(payload.url) : null,
  };
};

export const convertCaseScheduleToFormValues = (schedule: TCaseScheduleItem): Partial<TCaseScheduleForm> => {
  const dateConfirmDayjs = schedule.dateConfirm ? dayjs(schedule.dateConfirm, DATE_FORMAT_FOR_API) : null;

  const baseDate = dateConfirmDayjs || dayjs();
  const startTimeDayjs = schedule.startTimeConfirm
    ? baseDate
        .hour(parseInt(schedule.startTimeConfirm.split(":")[0]))
        .minute(parseInt(schedule.startTimeConfirm.split(":")[1]))
        .second(0)
        .millisecond(0)
    : null;

  return {
    dateTimeTalent: schedule.dateTimeTalent || "",
    talentIds: schedule.talents?.map((talent: Talent) => Number(talent.id)) || [],
    dateConfirm: dateConfirmDayjs,
    startTimeConfirm: startTimeDayjs ? startTimeDayjs.format("HH:mm:ss") : null,
    interviewMethod: schedule.interviewMethod || null,
    meetingToolType: schedule.meetingToolType || null,
    meetingId: schedule.meetingId || null,
    passcode: schedule.passcode || null,
    url: schedule.url || null,
    isConfirm: Boolean(schedule.isConfirm ?? !!(schedule.dateConfirm || schedule.url)),
  } as Partial<TCaseScheduleForm>;
};
